import React from 'react';
import { createStyleSheet } from './sheet';
import { analyzeCssInDev } from './dev-warnings';
import { useCache } from './provider';
// Variable declaration list because it's smaller.
var stylesheet;
export default function Style(props) {
    var children = props.children;
    var inserted = useCache();
    if (process.env.NODE_ENV === 'development') {
        analyzeCssInDev(children, props.hash);
    }
    // Will remove code on the client bundle.
    if ("object" === 'undefined') {
        if (!inserted[props.hash]) {
            inserted[props.hash] = true;
            return React.createElement("style", { nonce: props.nonce }, children);
        }
        return null;
    }
    if (!inserted[props.hash] && children) {
        // Keep re-assigning over ternary because it's smaller
        stylesheet = stylesheet || createStyleSheet(props);
        children.forEach(stylesheet);
        inserted[props.hash] = true;
    }
    return null;
}
//# sourceMappingURL=style.js.map